export const API_KEY = "2GvTlLMbd54OabL7Ol9cZSRD4xUIQiHBsHESqDZv2pOHAzFuoIWy4Q==";